module.exports = __webpack_public_path__ + "media/bootstrap-icons/thermometer-ba8e65f4.svg";